/**
 * Lê token e e-mail da query de redefinição de senha.
 * Normaliza `&amp;` (comum em links gerados a partir de e-mail HTML) para `&`.
 */
export function parsePasswordResetQueryParams(
  searchParams?: URLSearchParams,
  rawSearch?: string
): { token: string; email: string } {
  const search =
    rawSearch ??
    (typeof window !== 'undefined' ? window.location.search : '')

  const normalizedQuery = search
    .replace(/^\?/, '')
    .replace(/&amp;/gi, '&')
    .replace(/&#0*38;/gi, '&')

  const params = new URLSearchParams(normalizedQuery)

  if (searchParams) {
    const tokenFromRouter = searchParams.get('token')?.trim() ?? ''
    const emailFromRouter = searchParams.get('email')?.trim().toLowerCase() ?? ''

    if (tokenFromRouter) {
      const matchingNormalizedEmail = params.get('token')?.trim() === tokenFromRouter
        ? params.get('email')?.trim().toLowerCase() ?? ''
        : ''
      return { token: tokenFromRouter, email: emailFromRouter || matchingNormalizedEmail }
    }
  }

  return {
    token: params.get('token')?.trim() ?? '',
    email: params.get('email')?.trim().toLowerCase() ?? '',
  }
}
